import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Card, CardHeader, CardTitle, CardContent, Input, Button } from "./ui";
import { useAuth } from "../context/AuthContext";

const Login: React.FC = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await fetch("/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || "登录失败");
      }

      const data = await response.json();
      login(data.token);
      navigate("/");
    } catch (err) {
      setError(err instanceof Error ? err.message : "发生错误");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          {/* 添加 Logo */}
          <div className="flex justify-center mb-6">
            <img 
              src="/images/logo.png" 
              alt="佛教学院 Logo" 
              className="w-64 h-auto" // 这里设置宽度为 256px，高度自适应
              style={{
                maxWidth: '100%',
                objectFit: 'contain',
                width: '400px',
                height: 'auto'
              }}
            />
          </div>
          <CardTitle>登录</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            {error && (
              <div className="bg-red-50 text-red-500 p-3 rounded">{error}</div>
            )}
            <div>
              <label className="block text-sm font-medium text-gray-700">
                邮箱
              </label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="mt-1"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700">
                密码
              </label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1"
              />
            </div>
            <Button
              type="submit"
              className="w-full bg-blue-500 hover:bg-blue-600"
            >
              登录
            </Button>
            <div className="text-center mt-4">
              <Link
                to="/register"
                className="text-sm text-blue-600 hover:text-blue-500"
              >
                没有账号？立即注册
              </Link>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default Login;
